module.exports = __webpack_public_path__ + "static/media/logo-coral.575dac4d.svg";